import { createSlice } from "@reduxjs/toolkit";

import type { NapiRedeemableAmounts } from "@app/types/napi-v2";

import type { PayloadAction } from "@reduxjs/toolkit";

import { refreshRedeemableAmounts } from "./thunks/redeemable-amounts";

const initialState = null as NapiRedeemableAmounts | null;

const redeemableAmountsSlice = createSlice({
  name: "redeemable_amounts",
  initialState,
  reducers: {
    updateRedeemableAmounts: (
      _state,
      action: PayloadAction<NapiRedeemableAmounts | null>
    ) => {
      return action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(refreshRedeemableAmounts.rejected, () => {
      return null;
    });
  }
});

export const { updateRedeemableAmounts } = redeemableAmountsSlice.actions;
export default redeemableAmountsSlice.reducer;
